import { Form, Formik, FormikProps } from 'formik';
import * as React from 'react';
import { connect } from 'react-redux';

import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { withDefaultStyles } from '../../../utils/material-ui/hoc';

class SsoForm extends React.Component<any, any> {
    public render() {
        return (
            <div style={this.props.style}>
                <Formik
                    initialValues={{
                        apikey: this.props.auth.apikey
                    }}
                    onSubmit={this.props.onSubmit}
                    render={this.form}
                    enableReinitialize={true}
                />
            </div>
        );
    }
    private form = (p: FormikProps<any>) => <Form>
        <TextField
            required={true}
            label="API Key"
            type="text"
            name="apikey"
            InputLabelProps={{
                shrink: true,
            }}
            margin="normal"
            variant="outlined"
            placeholder="API KEY"
            fullWidth={true}
            value={p.values.apikey}
            onChange={p.handleChange}
            onBlur={p.handleBlur}
        />
        <Button style={{width: '100%'}} type="submit" color="primary">Update API Key</Button>
    </Form>
}


const mapStateToProps = (state, ownProps) => {
    return { ...state };
}

export default withDefaultStyles(connect(
    mapStateToProps,
)(SsoForm));



// WEBPACK FOOTER //
// ./src/sub-projects/openweathermap/components/sso-form.tsx